import { useEffect, useRef } from 'react';
import { PYTHON_BACKEND_DIPENDENZE_URL } from '@/config/endpoints';
import type { AuthenticatedUser } from '@/services/authService';
import { PermissionsHelper } from '@/types/permissions';

export function useBackendWarmup(user: AuthenticatedUser | null, loading: boolean): void {
  const firedRef = useRef(false);

  useEffect(() => {
    if (loading || !user || firedRef.current) return;

    const hasDipendenzeAccess =
      user.isAdmin ||
      new PermissionsHelper(user.permissions).canViewHub('dipendenze');

    if (!hasDipendenzeAccess) return;

    firedRef.current = true;

    fetch(`${PYTHON_BACKEND_DIPENDENZE_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(10_000),
    }).catch(() => {/* warmup silenzioso */});
  }, [loading, user]);
}
